import { render, staticRenderFns } from "./AppUsuageReport.vue?vue&type=template&id=127818f4&scoped=true&"
import script from "./AppUsuageReport.vue?vue&type=script&lang=js&"
export * from "./AppUsuageReport.vue?vue&type=script&lang=js&"
import style0 from "./AppUsuageReport.vue?vue&type=style&index=0&id=127818f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127818f4",
  null
  
)

export default component.exports